<template>
  <div class="siderbar" :class="{ minWidth: isCollapse }" :style="{'background':menuConfig.menu_background_color}">

    <el-scrollbar>
      <el-menu
        :default-active="activeRoutePath"
        class="el-menu-vertical-demo"
        :background-color="menuConfig.menu_background_color"
        :text-color="menuConfig.menu_text_color"
        :active-text-color="menuConfig.menu_ctive_text_color"
        mode="vertical"
        :collapse-transition="false"
        :collapse="isCollapse"
        router
      >
        <template v-for="item in myRoutes">
          <template v-if="!item.children || item.children.length == 0">
            <el-menu-item :index="item.path" :key="item.meta.title" :ref="item.name" :class="item.name">
              <i :class="['iconfont', 'menu-icon', item.meta.icon]" style="color:#FFF;"></i>
              <span slot="title">{{ item.meta.title }}</span>
            </el-menu-item>
          </template>

          <template v-if="item.children.length > 0">
            <el-submenu :index="item.path" :key="item.meta.title">
              <template slot="title">
                <i :class="['iconfont', 'menu-icon', item.meta.icon]" style="color:#FFF;"></i>
                <span slot="title">{{ item.meta.title }}</span>
              </template>
              <el-menu-item
                :class="['children-menu']"
                v-for="(code, codeindex) in item.children"
                :key="codeindex"
                :index="code.path"
                v-show="!code.hidden"
              >
                {{ code.meta.title }}
              </el-menu-item>
            </el-submenu>
          </template>
        </template>
      </el-menu>
      <!-- <dark-birght class="dark-birght" /> -->
    </el-scrollbar>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters, mapMutations } from "vuex";
// eslint-disable-next-line no-unused-vars
import router from "../../router";
import routes from "../../router/routes.js";
import { birght, dark } from "./menuTheme.js";
import DarkBirght from "@/components/dark_birght";
export default {
  name: "siderbar",
  components: {
    DarkBirght
  },
  data() {
    return {
      myRouteList: null,
      menuConfig: null
    };
  },
  computed: {
    ...mapGetters({
      isCollapse: "app/isCollapse",
      menuTheme: "app/menuTheme"
    }),
    activeRoutePath() {
      return this.$route.path;
    },
    myRoutes() {
      return routes.find(item => {
        if (!item.hidden) {
          return item.children.filter(code => {
            if (code.children) {
              code.children = code.children.filter(foo => !foo.hidden);
            } else {
              code.children = [];
            }
          });
        }
      }).children;
    }
  },
  created() {
    this.myRouteList = this.$router.options.routes;
    this.menuTheme === "birght" ? (this.menuConfig = birght) : (this.menuConfig = dark);

    if (this.$route.fullPath.indexOf('/organization') !== -1){
      this.$nextTick(() => {
        document.getElementsByClassName('organization')[0].className = 'el-menu-item organization is-active';
        document.getElementsByClassName('organization')[0].style.color = '#409EFF';
      })
    }
  },
  watch: {
    $route(to,from){
      if (to.path.indexOf('/organization') !== -1) {
        this.$nextTick(() => {
          document.getElementsByClassName('organization')[0].className = 'el-menu-item organization is-active';
          document.getElementsByClassName('organization')[0].style.color = '#409EFF';
        })
      } else {
        this.$nextTick(() => {
          document.getElementsByClassName('organization')[0].className = 'el-menu-item organization';
          document.getElementsByClassName('organization')[0].style.color = '#b5b6bd';
        })
      }
    },
    menuTheme(val) {
      val === "birght" ? (this.menuConfig = birght) : (this.menuConfig = dark);
    }
  },
  mounted() {

  },
  methods: {}
};
</script>

<style lang="scss">
@import "../../style/iconfont";
.dark-birght{
  // display: flex;
  // justify-content: center;
  // margin: 5px 0;
  position: absolute;
  bottom: 30px;
  left: 10px;
  // transform: translateX(-50%);
}
.menu-icon {
  margin-right: 8px;
  color: #ffffff;
}
.el-submenu__title i {
  color: #FFF !important;
}
.siderbar {
  position: fixed;
  top: 50px;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 200px;
  height: 100%;
  transition: width 0.3s;
  &.minWidth {
    width: 64px !important;
  }
  .el-scrollbar {
    height: 95.5%;
    .el-scrollbar__wrap {
      overflow-x: hidden !important;
    }
  }
}
.el-menu-item{
  &.is-active {
    background-color: #2e3241  !important;
  }
}
.children-menu {
  padding-right: 50px !important;
  // background-color: #323646 !important;
  border-left: 4px solid transparent;
  // a {
  //   display: block;
  //   color: #fff;
  // }
  // &:hover {
  //   background-color: #000000 !important;
  // }
  &.is-active {
    background-color: #2e3241  !important;
  }
}
.el-menu {
  border-right: 0 !important;
}
</style>
<style>

</style>
